import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './DateFilterTabs.css';

interface DateFilterTabsProps {
  onFilterChange: (filter: string, dateRange?: { from: string; to: string }) => void;
  activeFilter?: string;
}

const DateFilterTabs: React.FC<DateFilterTabsProps> = ({
  onFilterChange,
  activeFilter = 'today',
}) => {
  const [active, setActive] = useState(activeFilter);
  const [showCustomRange, setShowCustomRange] = useState(false);
  const [customRange, setCustomRange] = useState({ from: '', to: '' });

  const filters = [
    { id: 'today', label: 'Today', icon: 'bx-calendar-day' },
    { id: 'week', label: 'This Week', icon: 'bx-calendar-week' },
    { id: 'month', label: 'This Month', icon: 'bx-calendar-alt' },
    { id: 'year', label: 'This Year', icon: 'bx-calendar' },
    { id: 'custom', label: 'Custom Range', icon: 'bx-calendar-check' },
  ];

  const handleFilterClick = (filterId: string) => {
    setActive(filterId);

    if (filterId === 'custom') {
      setShowCustomRange(true);
    } else {
      setShowCustomRange(false);
      onFilterChange(filterId);
    }
  };

  const handleCustomRangeSubmit = () => {
    if (customRange.from && customRange.to) {
      onFilterChange('custom', customRange);
      setShowCustomRange(false);
    }
  };

  return (
    <div className="date-filter-tabs">
      <div className="filter-tabs-container">
        <div className="tabs-scroll">
          {filters.map((filter) => (
            <motion.button
              key={filter.id}
              className={`filter-tab ${active === filter.id ? 'active' : ''}`}
              onClick={() => handleFilterClick(filter.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <i className={`bx ${filter.icon}`}></i>
              <span>{filter.label}</span>
              {active === filter.id && <motion.div className="tab-indicator" layoutId="tab" />}
            </motion.button>
          ))}
        </div>
      </div>

      {showCustomRange && (
        <motion.div
          className="custom-range-picker"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
        >
          <div className="range-inputs">
            <div className="input-group">
              <label>From Date</label>
              <input
                type="date"
                value={customRange.from}
                onChange={(e) => setCustomRange({ ...customRange, from: e.target.value })}
              />
            </div>
            <div className="input-group">
              <label>To Date</label>
              <input
                type="date"
                value={customRange.to}
                onChange={(e) => setCustomRange({ ...customRange, to: e.target.value })}
              />
            </div>
            <button
              className="btn-apply"
              onClick={handleCustomRangeSubmit}
              disabled={!customRange.from || !customRange.to}
            >
              Apply
            </button>
            <button
              className="btn-cancel"
              onClick={() => {
                setShowCustomRange(false);
                setActive('today');
              }}
            >
              Cancel
            </button>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default DateFilterTabs;
